import React from 'react';
import { Building2, TrendingUp, Briefcase, Home, ArrowRight } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Building2,
  TrendingUp,
  Briefcase,
  Home
};

const ServicesSection = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-navy-50 rounded-full mb-6">
            <span className="w-2 h-2 bg-navy-600 rounded-full" />
            <span className="text-navy-700 text-sm font-semibold uppercase tracking-wider">Services</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Comprehensive Solutions
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            From property management to business consulting, we deliver end-to-end solutions designed to maximize your investments and drive growth.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-500 border border-slate-100 hover:border-navy-200 overflow-hidden"
              >
                {/* Hover Background Effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-navy-600 to-navy-800 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                {/* Content */}
                <div className="relative z-10">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-navy-100 group-hover:bg-white/20 rounded-2xl flex items-center justify-center mb-6 transition-colors duration-500">
                    <Icon className="w-8 h-8 text-navy-600 group-hover:text-white transition-colors duration-500" />
                  </div>

                  {/* Number */}
                  <span className="absolute top-8 right-8 text-6xl font-bold text-slate-100 group-hover:text-white/10 transition-colors duration-500">
                    0{index + 1}
                  </span>

                  {/* Title */}
                  <h3 className="text-2xl font-bold text-slate-900 group-hover:text-white mb-4 transition-colors duration-500">
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-slate-600 group-hover:text-silver-200 mb-6 transition-colors duration-500">
                    {service.description}
                  </p>

                  {/* CTA */}
                  <button
                    onClick={scrollToContact}
                    className="inline-flex items-center gap-2 text-navy-600 group-hover:text-white font-semibold transition-colors duration-500"
                  >
                    Learn More
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
